import { Link, useLocation } from "react-router-dom";
import { Badge } from "antd";
import { MailOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import HttpService from "../constant/Api";

export const Messages = () => {
  const { pathname, search } = useLocation();
  const [unread, setUnread] = useState(0);

  function checkForUnreadMessagesService() {
    // HttpService.get(`v1/notifications/inbox/status`)
    HttpService.get(`v2/inbox/status`)
      .then((r) => {
        setUnread(r.data.unreadCount);
      })
      .catch((e) => console.error(e));
  }

  useEffect(() => {
    checkForUnreadMessagesService();
  }, []);

  return (
    <Link
      className="messages-link"
      to={{
        pathname: "/messages",
        state: { prevPath: pathname + search },
      }}
    >
      <Badge className="messageUnreadBadge">
        <MailOutlined />
        {/* {isUnread && <span className="bullet"></span>} */}
        {unread > 0 && <span className="bullet">{unread}</span>}
      </Badge>
    </Link>
  );
};
